import { render, staticRenderFns } from "./datailEventFlow.vue?vue&type=template&id=53bd02ed&scoped=true"
import script from "./datailEventFlow.vue?vue&type=script&lang=js"
export * from "./datailEventFlow.vue?vue&type=script&lang=js"
import style0 from "./datailEventFlow.vue?vue&type=style&index=0&id=53bd02ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd02ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bd02ed')) {
      api.createRecord('53bd02ed', component.options)
    } else {
      api.reload('53bd02ed', component.options)
    }
    module.hot.accept("./datailEventFlow.vue?vue&type=template&id=53bd02ed&scoped=true", function () {
      api.rerender('53bd02ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/imageManagement/components/datailEventFlow.vue"
export default component.exports